// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthed-header-container {
  flex: 1 1;
  max-height: 50px;
  display: flex;
  flex-direction: row;
  padding: 10px;
  max-width: 100%;
}

.unauthed-header-title-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: x-large;
  margin-left: 10px;
  height: 100%;
}

.unauthed-header-menu-bar-container {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-size: large;
  flex: 1 1;
}

.unauthed-header-menu-bar-item-container:hover {
  background-color: rgb(220, 241, 255);
  border-width: 1px;
  border-color: rgb(135, 161, 167);
  border-style: solid;
  padding-left:5px;
  padding-right:5px;
  border-radius: 3px;
}

.unauthed-header-menu-bar-item-container.selected {
  background-color: rgb(220, 241, 255);
  border-width: 1px;
  border-color: rgb(135, 161, 167);
  border-style: solid;
  padding-left:5px;
  padding-right:5px;
  border-radius: 3px;
}


@media(max-width: 550px) {
  .unauthed-header-menu-bar-item-container {
    font-size: small
  }
  .unauthed-header-title-text {
    font-size: large;
  }
}

@media(max-width: 400px) {
  .unauthed-header-menu-bar-item-container {
    font-size: x-small
  }
  .unauthed-header-title-text {
    font-size: medium;
  }
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/UnauthedHeader/UnauthedHeader.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE;IACE;EACF;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE;EACF;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".unauthed-header-container {\n  flex: 1;\n  max-height: 50px;\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  max-width: 100%;\n}\n\n.unauthed-header-title-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: x-large;\n  margin-left: 10px;\n  height: 100%;\n}\n\n.unauthed-header-menu-bar-container {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  font-size: large;\n  flex: 1;\n}\n\n.unauthed-header-menu-bar-item-container:hover {\n  background-color: rgb(220, 241, 255);\n  border-width: 1px;\n  border-color: rgb(135, 161, 167);\n  border-style: solid;\n  padding-left:5px;\n  padding-right:5px;\n  border-radius: 3px;\n}\n\n.unauthed-header-menu-bar-item-container.selected {\n  background-color: rgb(220, 241, 255);\n  border-width: 1px;\n  border-color: rgb(135, 161, 167);\n  border-style: solid;\n  padding-left:5px;\n  padding-right:5px;\n  border-radius: 3px;\n}\n\n\n@media(max-width: 550px) {\n  .unauthed-header-menu-bar-item-container {\n    font-size: small\n  }\n  .unauthed-header-title-text {\n    font-size: large;\n  }\n}\n\n@media(max-width: 400px) {\n  .unauthed-header-menu-bar-item-container {\n    font-size: x-small\n  }\n  .unauthed-header-title-text {\n    font-size: medium;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
